module.exports = __webpack_public_path__ + "media/tie.07646e1b.mp3";